export type WSRoute =
  | 'analysis'
  | 'export'
  | 'materials-demands-export'
  | 'po-components-export'
  | 'stock-export'
  | 'bom-imports'
  | 'stock-and-po-imports'
  | 'sap-imports';

export const ANALYSIS_TERMINAL_STATUSES = ['FINISHED', 'ERROR', 'CANCELED', 'COMPLETED'] as const;
export const EXPORT_TERMINAL_STATUSES = ['FINISHED', 'ERROR'] as const;
export const IMPORT_TERMINAL_STATUSES = ['DONE', 'FAILED', 'ERROR'] as const;

export interface ConnectionDescriptor {
  route: WSRoute;
  id?: number;
  storageKey: string;
}

export interface HandlerContext {
  descriptor: ConnectionDescriptor;
  send: (payload: unknown) => void;
  closeSelf: (code?: number) => void;
}

export interface DomainHandler {
  onOpen?: (ctx: HandlerContext) => void;
  onMessage: (msg: unknown, ctx: HandlerContext) => boolean;
  onClose?: (event: CloseEvent, ctx: HandlerContext) => void;
}
